import React from "react";
import "./style.scss";

const StatusFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="status-page-footer">
      <p>© {currentYear}, Aditya Birla Capital Ltd. All Rights Reserved.</p>
      <p>
        Call us toll free : <i className="fa-solid fa-phone"></i> 1800 270 7000
      </p>
    </footer>
  );
};

export default StatusFooter;
